import React, { useState, useMemo } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight, MapPin, Home, ChevronLeft, ChevronRight } from 'lucide-react';

const WHATSAPP_LINK = "https://wa.me/529841585732?text=Hola%2C%20me%20interesa%20una%20casa%20en%20Senderos";
const MXN_TO_USD = 20;
const GDIMG = (id) => `https://lh3.googleusercontent.com/d/${id}=w800`;

const ARTIFACT = (slug) => `https://customer-assets.emergentagent.com/job_tulum-investment-lab/artifacts/${slug}`;

const ALL_HOUSES = [
  // Senderos Norte
  { id: 'casa-oscar', name: 'Casa Os', zone: 'Senderos Norte', city: 'Playa del Carmen', priceMXN: 7900000, status: 'Venta', image: ARTIFACT('uqs24r49_PHOTO-2024-03-24-15-03-49.jpg'), bedrooms: 3 },
  { id: 'rosaleda-bucio', name: 'Casa Rosaleda Bucio', zone: 'Senderos Norte', city: 'Playa del Carmen', priceMXN: 6500000, status: 'Venta', image: ARTIFACT('830p7be4_53cd5dad-8354-4a18-a18d-238a314eb6ba.jpg'), bedrooms: 3 },
  { id: 'casa-sergio', name: 'Casa Ser', zone: 'Senderos Norte', city: 'Playa del Carmen', priceMXN: 8000000, status: 'Venta', image: GDIMG('1aAkceky0KPw26ZP0RLFafH54Hkl_olv5'), bedrooms: 4 },
  { id: 'rosaleda-32-34', name: 'Casas Rosaleda 32-34', zone: 'Senderos Norte', city: 'Playa del Carmen', priceMXN: 6900000, status: 'Venta', image: ARTIFACT('0nchwv1p_ChatGPT%20Image%204%20may%202026%2C%2012_52_33%20p.m..png'), bedrooms: 3 },
  { id: 'rosaleda-4', name: 'Rosaleda 4', zone: 'Senderos Norte', city: 'Playa del Carmen', priceMXN: 6900000, status: 'Venta', image: GDIMG('1bbquevoiwdguSKCuZxHdGGv5eH7IUZbj'), bedrooms: 3 },
  { id: 'rosaleda-13', name: 'Rosaleda 13 SN', zone: 'Senderos Norte', city: 'Playa del Carmen', priceUSD: 349500, status: 'Venta', image: ARTIFACT('a2ktfsz7_File_001.png'), bedrooms: 4 },
  { id: 'rosaleda-30', name: 'Rosaleda 30', zone: 'Senderos Norte', city: 'Playa del Carmen', priceMXN: 9200000, status: 'Venta', image: ARTIFACT('uwp1cigv_9e5d210a-de39-418e-b8da-9a608826efe0.jpg'), bedrooms: 4 },
  // Senderos Sur
  { id: 'casa-arboleda', name: 'Casa Arboleda', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 12000000, status: 'Preventa', image: ARTIFACT('j9jjnxtb_image.png'), bedrooms: 4 },
  { id: 'centenario-17', name: 'Casa Centenario 17', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 9900000, status: 'Venta', image: ARTIFACT('6xopuy8x_PHOTO-2025-02-04-11-24-44.jpg'), bedrooms: 3 },
  { id: 'chapultepec-38', name: 'Casa Chapultepec 38 SM', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 13900000, status: 'Venta', image: ARTIFACT('9zlm841g_DSC02759.jpg'), bedrooms: 5 },
  { id: 'casa-inma', name: 'Casa Inma', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 8950000, status: 'Venta', image: GDIMG('16l4PTOhV3n012a2zjJ3r9Pre-w9mp2zx'), bedrooms: 3 },
  { id: 'casa-senderos', name: 'Casa Senderos', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 9950000, status: 'Venta', image: GDIMG('1nU9B8DynQ2eyRhRIOwq1B4MKhktEvyc8'), bedrooms: 4 },
  { id: 'guell-16', name: 'Parque Güell 16', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 12900000, status: 'Venta', image: GDIMG('1A1m86Volr-sXVz385ZKxwDlvNNsB0tIA'), bedrooms: 4 },
  { id: 'guell-20', name: 'Parque Güell 20', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 8500000, status: 'Preventa', image: ARTIFACT('dqurn9hx_Render%20fachada%20posterior.jpeg'), bedrooms: 3 },
  { id: 'kabah', name: 'Kabah', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 8500000, status: 'Venta', image: ARTIFACT('ea1c3p2x_PHOTO-2025-10-02-16-51-38.jpg'), bedrooms: 3 },
  { id: 'guell-43', name: 'Parque Güell 43', zone: 'Senderos Sur', city: 'Playa del Carmen', priceMXN: 5500000, status: 'Venta', image: ARTIFACT('z9po048l_PHOTO-2026-02-22-14-15-29.jpg'), bedrooms: 2 },
];

const ZONES = ['Todo', 'Senderos Norte', 'Senderos Sur'];
const STATUSES = ['Todo', 'Venta', 'Preventa'];
const PER_PAGE = 6;

const formatPrice = (house, language) => {
  if (house.priceUSD) {
    const mxn = house.priceUSD * MXN_TO_USD;
    return language === 'es'
      ? `$${house.priceUSD.toLocaleString('en-US')} USD · $${mxn.toLocaleString('es-MX')} MXN`
      : `$${house.priceUSD.toLocaleString('en-US')} USD · $${mxn.toLocaleString('es-MX')} MXN`;
  }
  const usd = Math.round(house.priceMXN / MXN_TO_USD);
  return language === 'es'
    ? `$${house.priceMXN.toLocaleString('es-MX')} MXN · ~$${usd.toLocaleString('en-US')} USD`
    : `$${usd.toLocaleString('en-US')} USD · $${house.priceMXN.toLocaleString('es-MX')} MXN`;
};

const HouseCard = ({ h, language }) => (
  <div
    className="bg-white border border-[#0A2235]/5 overflow-hidden group hover:shadow-lg transition-all duration-300 rounded-[20px]"
    data-testid={`house-${h.id}`}
  >
    <div className="relative h-60 overflow-hidden bg-[#D4EDE8]/30">
      <img src={h.image} alt={h.name} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" loading="lazy" />
      <div className={`absolute top-4 left-4 px-3 py-1 text-xs font-medium rounded-full ${h.status === 'Preventa' ? 'bg-[#2BBFBF] text-[#0A2235]' : 'bg-[#0A2235] text-[#2BBFBF]'}`}>
        {language === 'en' ? ({ 'Venta': 'Sale', 'Preventa': 'Pre-sale' }[h.status] || h.status) : h.status}
      </div>
      <div className="absolute top-4 right-4 bg-[#0A2235]/80 text-[#FAFAF7] px-2.5 py-1 text-xs font-inter rounded-full flex items-center gap-1">
        <Home className="w-3 h-3" />
        {h.bedrooms} {language === 'es' ? 'Rec.' : 'Bed.'}
      </div>
    </div>
    <div className="p-5">
      <h3 className="font-playfair text-xl text-[#0A2235] mb-1">{h.name}</h3>
      <div className="flex items-center gap-1 text-[#2BBFBF] text-sm mb-3">
        <MapPin className="w-3.5 h-3.5" />
        <span className="font-inter">{h.zone} · {h.city}</span>
      </div>
      <p className="font-playfair text-lg text-[#0A2235] mb-4">
        {formatPrice(h, language)}
      </p>
      <a href={`${WHATSAPP_LINK}%20-%20${encodeURIComponent(h.name)}`} target="_blank" rel="noopener noreferrer">
        <Button className="w-full bg-[#0A2235] hover:bg-[#2BBFBF] hover:text-[#0A2235] text-[#FAFAF7] rounded-full transition-all duration-300 group/btn" data-testid={`house-btn-${h.id}`}>
          {language === 'es' ? 'Solicitar información' : 'Request info'}
          <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
        </Button>
      </a>
    </div>
  </div>
);

export const Casas = () => {
  const { language } = useLanguage();
  const [zoneFilter, setZoneFilter] = useState('Todo');
  const [statusFilter, setStatusFilter] = useState('Todo');
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = useMemo(() => {
    return ALL_HOUSES.filter(h => {
      if (zoneFilter !== 'Todo' && h.zone !== zoneFilter) return false;
      if (statusFilter !== 'Todo' && h.status !== statusFilter) return false;
      return true;
    });
  }, [zoneFilter, statusFilter]);

  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paginated = filtered.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE);

  const handleFilter = (type, value) => {
    if (type === 'zone') setZoneFilter(value);
    else setStatusFilter(value);
    setCurrentPage(1);
  };

  return (
    <section id="casas" data-testid="casas-section" className="bg-[#FAFAF7] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16 lg:px-24">
        {/* Aurven-style header */}
        <div className="text-center mb-16">
          <span className="inline-block font-inter text-xs uppercase tracking-[0.25em] text-[#0A2235]/60 border border-[#0A2235]/15 px-4 py-1.5 rounded-sm mb-8">
            {language === 'es' ? 'Casas en Senderos' : 'Houses in Senderos'}
          </span>
          <h2 className="font-playfair text-[clamp(2rem,5vw,4rem)] text-[#0A2235] leading-[1.08] tracking-tight mb-4" data-testid="casas-title">
            {language === 'es' ? (
              <>Casas en Playa del <em className="text-[#2BBFBF]">Carmen</em></>
            ) : (
              <>Houses in Playa del <em className="text-[#2BBFBF]">Carmen</em></>
            )}
          </h2>
          <p className="font-inter text-[#0A2235]/50 max-w-2xl mx-auto leading-[1.7] text-sm">
            {language === 'es'
              ? 'Descubre casas residenciales en los exclusivos fraccionamientos Senderos Norte y Sur, en el corazón de Playa del Carmen.'
              : 'Discover residential houses in the exclusive Senderos Norte and Sur developments in the heart of Playa del Carmen.'}
          </p>
        </div>

        {/* Filters */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 mb-4" data-testid="casas-zone-filters">
            {ZONES.map(z => (
              <button key={z} onClick={() => handleFilter('zone', z)}
                className={`px-4 py-2 text-sm font-inter rounded-full transition-all ${zoneFilter === z ? 'bg-[#0A2235] text-[#FAFAF7] font-semibold' : 'bg-[#0A2235]/5 text-[#0A2235]/70 hover:bg-[#0A2235]/10'}`}
                data-testid={`casas-filter-${z}`}>
                {z === 'Todo' && language === 'en' ? 'All' : z}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap gap-2" data-testid="casas-status-filters">
            {STATUSES.map(s => (
              <button key={s} onClick={() => handleFilter('status', s)}
                className={`px-4 py-2 text-sm font-inter rounded-full transition-all ${statusFilter === s ? 'bg-[#2BBFBF] text-[#0A2235] font-semibold' : 'bg-[#0A2235]/5 text-[#0A2235]/70 hover:bg-[#0A2235]/10'}`}
                data-testid={`casas-status-${s}`}>
                {language === 'en' ? ({ 'Todo': 'All', 'Venta': 'Sale', 'Preventa': 'Pre-sale' }[s] || s) : s}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {paginated.map(h => <HouseCard key={h.id} h={h} language={language} />)}
        </div>

        {/* Empty state */}
        {filtered.length === 0 && (
          <div className="text-center py-16">
            <p className="font-inter text-[#0A2235]/50 text-lg">{language === 'es' ? 'No hay casas con estos filtros.' : 'No houses match these filters.'}</p>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 mt-12" data-testid="casas-pagination">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}
              className="w-10 h-10 rounded-full flex items-center justify-center bg-[#0A2235]/5 text-[#0A2235]/70 hover:bg-[#0A2235]/10 disabled:opacity-30 transition-all"
              data-testid="casas-page-prev">
              <ChevronLeft className="w-5 h-5" />
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
              <button key={page} onClick={() => setCurrentPage(page)}
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-inter transition-all ${currentPage === page ? 'bg-[#0A2235] text-[#FAFAF7] font-bold' : 'bg-[#0A2235]/5 text-[#0A2235]/70 hover:bg-[#0A2235]/10'}`}
                data-testid={`casas-page-${page}`}>
                {page}
              </button>
            ))}
            <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}
              className="w-10 h-10 rounded-full flex items-center justify-center bg-[#0A2235]/5 text-[#0A2235]/70 hover:bg-[#0A2235]/10 disabled:opacity-30 transition-all"
              data-testid="casas-page-next">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        )}

        {/* Results count */}
        <p className="text-center font-inter text-[#0A2235]/40 text-sm mt-4">
          {language === 'es'
            ? `Mostrando ${paginated.length} de ${filtered.length} casas`
            : `Showing ${paginated.length} of ${filtered.length} houses`}
        </p>
      </div>
    </section>
  );
};
